import { LangCode, type InputMaybe } from "@/lib/gql/__generated__/graphql";

import { QuestionForMain } from "@/components/features/_layouts/island/main/question";
import type { ForNodeType } from "@/components/features/_model/types";

import { QuestionEmailTemplateItem } from "../_shared/components/email-template-item";

type Props = {
	mailTemplate: ForNodeType<InputMaybe<string> | undefined> | undefined;
	onSetMailTemplate: (value: string) => void;

	onSendTestEmailCreated: (emailAddress: string) => Promise<void>;

	hotelEmailAddress: string;

	title?: string;
	guide?: string;
};

export const QuestionCampaignEmailTemplates = ({
	mailTemplate,
	onSetMailTemplate,
	onSendTestEmailCreated: _onSendTestEmailCreated,
	hotelEmailAddress,

	title: _title,
	guide: _guide,
}: Props) => {
	const sendTestEmailCreated = async ({ lang: _lang, email }: { lang: LangCode; email: string }) => {
		await _onSendTestEmailCreated(email);
	};

	const title = _title || "ギフトと共にゲストに送信されるメールの内容設定";
	const guide =
		_guide ||
		"ゲストに送信されるメールの内容をカスタマイズできます。<br /> 「テスト送信」ボタンからテスト送信ができ、実際に確認できます。";

	return (
		<QuestionForMain
			required={true}
			title={title}
			guide={guide}
			inputChildren={
				<div className="space-y-6">
					<QuestionEmailTemplateItem
						lang={LangCode.Default}
						label={"ギフトと共に送られるメール文言"}
						dialogTitle={"ギフトと共"}
						value={mailTemplate?.value}
						errorMessage={mailTemplate?.error}
						handleChange={onSetMailTemplate}
						sendTestEmail={sendTestEmailCreated}
						hotelEmailAddress={hotelEmailAddress}
					/>
				</div>
			}
		/>
	);
};

QuestionCampaignEmailTemplates.displayName = "QuestionCampaignEmailTemplates";
